module.exports = __webpack_public_path__ + "static/media/svg-sprites.01767e26.svg";